import { api } from './services/api';

// Fallback data in case the API is not available
const mockData = {
  featuredCourses: [
    {
      id: '1',
      title: 'Les fondamentaux de la petite enfance',
      description: 'Découvrez les bases essentielles pour travailler avec les tout-petits',
      level: 'Débutant',
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '2',
      title: "Développement de l'enfant",
      description: 'Comprendre les étapes clés du développement de 0 à 3 ans',
      level: 'Intermédiaire',
      image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '3',
      title: 'Sécurité et premiers secours',
      description: 'Les gestes essentiels pour la sécurité des enfants',
      level: 'Tous niveaux',
      image: 'https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?auto=format&fit=crop&q=80&w=800'
    }
  ]
};

// Wrapper functions that try the API first, then fall back to mock data
export const getFeaturedCourses = async () => {
  try {
    return await api.getFeaturedCourses();
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return mockData.featuredCourses;
  }
};

export const getTestimonials = async () => {
  try {
    return await api.getTestimonials();
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return [
    {
      id: '1',
      name: 'Marie Laurent',
      role: 'Assistante maternelle',
      content: 'La formation m\'a permis d\'obtenir ma VAE avec succès. Le contenu est très pratique et adapté à nos besoins quotidiens.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '2',
      name: 'Sophie Martin',
      role: 'Éducatrice de jeunes enfants',
      content: 'Une formation complète qui m\'a donné tous les outils nécessaires pour progresser dans ma carrière.',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=800'
    }
    ];
  }
};

export const getModules = async () => {
  try {
    return await api.getModules();
  } catch (error) {
    const modules = [
      {
        id: 'VAE-1',
        code: 'VAE-1',
        title: 'Le métier d\'auxiliaire de puériculture',
        description: 'Découvrez les missions, les compétences et le quotidien d\'un auxiliaire de puériculture'
      },
      {
        id: 'VAE-2',
        code: 'VAE-2',
        title: 'La VAE',
        description: 'Comprendre le processus de Validation des Acquis de l\'Expérience et ses étapes clés'
      },
      {
        id: '1',
        code: 'BC1',
        title: 'Accompagner le développement du jeune enfant',
        description: `* Compétence 1 - Identifier, dans l'environnement, les éléments répondant aux besoins fondamentaux de l'enfant et prendre en compte sa singularité
* Compétence 2 - Mettre en œuvre les conditions favorables à l'activité libre et à l'expérimentation dans un contexte donné
* Compétence 3 - Mettre en œuvre des activités d'éveil en tenant compte de la singularité de l'enfant`,
      },
      {
        id: '2',
        code: 'BC2',
        title: 'Exercer son activité en accueil collectif',
        description: `* Compétence 4 - Établir une relation privilégiée et sécurisante avec l'enfant
* Compétence 5 - Coopérer avec l'ensemble des acteurs concernés dans un but de cohérence, d'adaptation et de continuité de l'accompagnement
* Compétence 6 - Assurer une assistance pédagogique au personnel enseignant`,
      },
      {
        id: '3',
        code: 'BC3',
        title: 'Exercer son activité en accueil individuel',
        description: `* Compétence 7 - Organiser son action dans le respect du cadre réglementaire et institutionnel
* Compétence 8 - Assurer les opérations d'entretien du logement et des espaces réservés à l'enfant
* Compétence 9 - Élaborer des repas`,
      },
      {
        id: '4',
        code: 'BC4',
        title: 'Communication professionnelle',
        description: `* Compétence 10 - Rechercher, traiter et transmettre, quels que soient l'outil et les modalités de communication, les données pertinentes pour assurer la continuité et la traçabilité des soins et des activités
* Compétence 11 - Organiser son activité, coopérer au sein d'une équipe pluri-professionnelle et améliorer sa pratique dans le cadre d'une démarche qualité et gestion des risques`,
      },
      {
        id: '5',
        code: 'BC5',
        title: 'Positionnement professionnel',
        description: `* Compétence 12 - Développer une posture professionnelle adaptée
* Compétence 13 - Actualiser ses connaissances et développer ses compétences
* Compétence 14 - Gérer son stress et adapter ses attitudes en fonction des situations`,
      }
    ].sort((a, b) => a.id.localeCompare(b.id));

    console.warn('Failed to fetch from API, using mock data:', error);
    return modules;
  }
};

export const getSubModules = async (moduleId: string) => {
  try {
    return await api.getSubModules(moduleId);
  } catch (error) {
    if (moduleId === 'VAE-1') {
      return [{
        id: 'VAE-1-1',
        moduleId: 'VAE-1',
        title: 'Le métier d\'auxiliaire de puériculture',
        description: 'Découvrez les missions, compétences et le quotidien',
        icon: 'Baby'
      }];
    } else if (moduleId === 'VAE-2') {
      return [{
        id: 'VAE-2-1',
        moduleId: 'VAE-2',
        title: 'La VAE',
        description: 'Comprendre le processus et ses étapes',
        icon: 'Crown'
      }];
    } else {
      console.warn('Failed to fetch from API, using mock data:', error);
      return [
        {
          id: '1',
          moduleId,
          title: 'Accueil individualisé',
          description: 'Techniques et pratiques pour un accueil adapté'
        },
        {
          id: '2',
          moduleId,
          title: 'Développement de l\'enfant',
          description: 'Comprendre les étapes du développement'
        },
        {
          id: '3',
          moduleId,
          title: 'Communication avec l\'enfant',
          description: 'Établir une communication adaptée'
        }
      ];
    }
  }
};

export const getModuleCourses = async (subModuleId: string) => {
  try {
    return await api.getModuleCourses(subModuleId);
  } catch (error) {
    if (subModuleId === 'VAE-1-1') {
      return [{
        id: 'VAE-1',
        subModuleId: 'VAE-1-1',
        title: 'Le métier d\'auxiliaire de puériculture',
        description: 'Découvrez les missions, compétences et le quotidien',
        hasVideo: false,
        icon: 'Baby'
      }];
    } else if (subModuleId === 'VAE-2-1') {
      return [{
        id: 'VAE-2',
        subModuleId: 'VAE-2-1',
        title: 'La VAE',
        description: 'Comprendre le processus et ses étapes',
        hasVideo: false,
        icon: 'Crown'
      }];
    } else {
      console.warn('Failed to fetch from API, using mock data:', error);
      return [
        {
          id: '1',
          subModuleId,
          title: 'Les premiers contacts',
          description: 'Établir une relation de confiance dès le début',
          hasVideo: true
        },
        {
          id: '2',
          subModuleId,
          title: 'L\'adaptation progressive',
          description: 'Mettre en place une période d\'adaptation réussie',
          hasVideo: true
        },
        {
          id: '3',
          subModuleId,
          title: 'Les rituels d\'accueil',
          description: 'Créer des repères sécurisants',
          hasVideo: false
        }
      ];
    }
  }
};

export const getSubModuleProgress = async (moduleId: string) => {
  try {
    return await api.getModuleProgress(moduleId);
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return [
    { id: '1', progress: 100 },
    { id: '2', progress: 66 },
    { id: '3', progress: 0 }
    ];
  }
};

export const getQuizQuestions = async (moduleIds: string[]) => {
  try {
    return await api.getQuizQuestions(moduleIds);
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return [
    {
      id: '1',
      moduleId: '1',
      question: 'Quelle est la première étape importante lors de l\'accueil d\'un nouvel enfant ?',
      options: [
        'Commencer immédiatement les activités',
        'Établir un dialogue avec les parents',
        'Préparer le matériel pédagogique',
        'Remplir les documents administratifs'
      ],
      correctAnswer: 1,
      explanation: 'Le dialogue avec les parents est crucial lors du premier accueil. Il permet de comprendre les habitudes de l\'enfant, ses besoins spécifiques et d\'établir une relation de confiance essentielle pour une adaptation réussie.',
      difficulty: 'facile'
    },
    {
      id: '2',
      moduleId: '2',
      question: 'À quel âge un enfant commence-t-il généralement à marcher ?',
      options: [
        'Entre 6 et 8 mois',
        'Entre 9 et 13 mois',
        'Entre 12 et 18 mois',
        'Entre 18 et 24 mois'
      ],
      correctAnswer: 2,
      explanation: 'La marche autonome se développe généralement entre 12 et 18 mois. Cette période est une moyenne, chaque enfant se développant à son propre rythme. Des facteurs comme l\'environnement et les opportunités d\'exercice peuvent influencer cette acquisition.',
      difficulty: 'moyen'
    }
    ];
  }
};

export const saveQuizResult = async (result: QuizResult): Promise<void> => {
  try {
    return await api.saveQuizResult(result);
  } catch (error) {
    console.warn('Failed to save to API:', error);
    console.log('Quiz result (mock):', result);
  }
};

export const getQuizStatistics = async (): Promise<QuizStatistics[]> => {
  try {
    return await api.getQuizStatistics();
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return [
    {
      id: '8',
      date: '2024-03-20T16:30:00Z',
      moduleResults: [
        {
          moduleId: '1',
          moduleName: 'Accueil et accompagnement de l\'enfant',
          correct: 9,
          total: 10,
          percentage: 90
        },
        {
          moduleId: '2',
          moduleName: 'Projet d\'accueil et prévention',
          correct: 9,
          total: 10,
          percentage: 90
        },
        {
          moduleId: '3',
          moduleName: 'Accompagnement au quotidien',
          correct: 8,
          total: 10,
          percentage: 80
        }
      ],
      totalCorrect: 26,
      totalQuestions: 30,
      overallPercentage: 87
    },
    {
      id: '7',
      date: '2024-03-20T10:30:00Z',
      moduleResults: [
        {
          moduleId: '1',
          moduleName: 'Accueil et accompagnement de l\'enfant',
          correct: 8,
          total: 10,
          percentage: 80
        },
        {
          moduleId: '2',
          moduleName: 'Projet d\'accueil et prévention',
          correct: 7,
          total: 10,
          percentage: 70
        },
        {
          moduleId: '3',
          moduleName: 'Accompagnement au quotidien',
          correct: 7,
          total: 10,
          percentage: 70
        }
      ],
      totalCorrect: 22,
      totalQuestions: 30,
      overallPercentage: 73
    },
    {
      id: '6',
      date: '2024-03-19T15:45:00Z',
      moduleResults: [
        {
          moduleId: '1',
          moduleName: 'Accueil et accompagnement de l\'enfant',
          correct: 7,
          total: 10,
          percentage: 70
        },
        {
          moduleId: '2',
          moduleName: 'Projet d\'accueil et prévention',
          correct: 6,
          total: 10,
          percentage: 60
        },
        {
          moduleId: '3',
          moduleName: 'Accompagnement au quotidien',
          correct: 5,
          total: 10,
          percentage: 50
        }
      ],
      totalCorrect: 18,
      totalQuestions: 30,
      overallPercentage: 60
    },
    {
      id: '5',
      date: '2024-03-18T14:20:00Z',
      moduleResults: [
        {
          moduleId: '1',
          moduleName: 'Accueil et accompagnement de l\'enfant',
          correct: 6,
          total: 10,
          percentage: 60
        },
        {
          moduleId: '2',
          moduleName: 'Projet d\'accueil et prévention',
          correct: 5,
          total: 10,
          percentage: 50
        },
        {
          moduleId: '3',
          moduleName: 'Accompagnement au quotidien',
          correct: 4,
          total: 10,
          percentage: 40
        }
      ],
      totalCorrect: 15,
      totalQuestions: 30,
      overallPercentage: 50
    },
    {
      id: '4',
      date: '2024-03-17T09:15:00Z',
      moduleResults: [
        {
          moduleId: '1',
          moduleName: 'Accueil et accompagnement de l\'enfant',
          correct: 5,
          total: 10,
          percentage: 50
        },
        {
          moduleId: '2',
          moduleName: 'Projet d\'accueil et prévention',
          correct: 4,
          total: 10,
          percentage: 40
        },
        {
          moduleId: '3',
          moduleName: 'Accompagnement au quotidien',
          correct: 6,
          total: 10,
          percentage: 60
        }
      ],
      totalCorrect: 15,
      totalQuestions: 30,
      overallPercentage: 50
    }
    ];
  }
};

export const getUserProfile = async (): Promise<UserProfile> => {
  try {
    return await api.getUserProfile();
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return {
    id: '1',
    email: 'marie.dubois@gmail.com',
    name: 'Marie Dubois',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=800',
    role: 'Assistante maternelle',
    joinedAt: '2024-01-15T08:00:00Z'
    };
  }
};

export const getCourseContent = async (courseId: string): Promise<CourseContent> => {
  try {
    return await api.getCourseContent(courseId);
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    const mockContent: Record<string, CourseContent> = {
    'VAE-1': {
      id: 'VAE-1',
      title: 'Le métier d\'Auxiliaire de puériculture',
      type: 'markdown',
      content: `# Le métier d'Auxiliaire de puériculture

L'auxiliaire de puériculture est un professionnel de santé qui joue un rôle essentiel dans l'accompagnement des enfants et de leurs familles.

## Les missions principales

* **Soins quotidiens**
  - Hygiène corporelle
  - Alimentation
  - Sommeil
  - Confort

* **Activités d'éveil**
  - Jeux adaptés à l'âge
  - Stimulation psychomotrice
  - Développement sensoriel
  - Socialisation

* **Surveillance et sécurité**
  - Observation de l'état de santé
  - Prévention des accidents
  - Premiers secours
  - Respect des protocoles

## Les qualités requises

* Patience et bienveillance
* Sens de l'observation
* Capacité d'adaptation
* Travail en équipe
* Résistance physique
* Rigueur et organisation

## Les lieux d'exercice

* Crèches collectives
* Haltes-garderies
* Services de maternité
* Services de pédiatrie
* Protection Maternelle et Infantile (PMI)
* Structures d'accueil spécialisées

## Formation et évolution

* **Formation initiale**
  - Diplôme d'État d'Auxiliaire de Puériculture (DEAP)
  - 44 semaines de formation
  - Alternance cours/stages

* **Évolution possible**
  - Éducateur de jeunes enfants
  - Infirmier puériculteur
  - Responsable de structure

## Rémunération

* Secteur public : 1600€ - 2200€ brut
* Secteur privé : 1500€ - 2500€ brut
* Variables selon expérience et lieu d'exercice`,
      moduleId: 'VAE-1',
      subModuleId: 'VAE-1'
    },
    'VAE-2': {
      id: 'VAE-2',
      title: 'La VAE',
      type: 'markdown',
      content: `# La Validation des Acquis de l'Expérience (VAE)

La VAE permet d'obtenir un diplôme grâce à votre expérience professionnelle. C'est une voie d'accès au DEAP particulièrement adaptée aux professionnels de la petite enfance.

## Les conditions d'accès

* **Expérience requise**
  - 1 an minimum d'expérience
  - En rapport direct avec le diplôme visé
  - Activités salariées, non salariées ou bénévoles

* **Pas de condition de diplôme**
  - Accessible à tous niveaux
  - Valorisation de l'expérience terrain

## Les étapes de la VAE

1. **Information et conseil**
   - Réunions d'information
   - Choix du diplôme
   - Évaluation de la faisabilité

2. **Recevabilité (Livret 1)**
   - Constitution du dossier
   - Justificatifs d'expérience
   - Délai de réponse : 2 mois

3. **Accompagnement**
   - Aide méthodologique
   - Préparation du dossier
   - Simulation d'entretien

4. **Rédaction du dossier (Livret 2)**
   - Description des activités
   - Analyse des compétences
   - Preuves de l'expérience

5. **Passage devant le jury**
   - Présentation du dossier
   - Entretien avec le jury
   - Mise en situation possible

## Les avantages de la VAE

* Reconnaissance officielle des compétences
* Maintien de l'activité professionnelle
* Évolution de carrière facilitée
* Renforcement de la confiance en soi

## Notre accompagnement

* **Suivi personnalisé**
  - Expert dédié
  - Rendez-vous réguliers
  - Support à distance

* **Ressources pédagogiques**
  - Cours en ligne
  - QCM d'entraînement
  - Vidéos explicatives

* **Préparation au jury**
  - Simulations
  - Conseils personnalisés
  - Gestion du stress`,
      moduleId: 'VAE-2',
      subModuleId: 'VAE-2'
    },
    '1': {
      id: '1',
      title: 'Les premiers contacts',
      type: 'video',
      content: 'Dans cette vidéo, nous abordons les techniques essentielles pour établir un premier contact positif avec l\'enfant...',
      videoUrl: 'https://player.vimeo.com/video/824804225',
      duration: '15 minutes',
      moduleId: '1',
      subModuleId: '1'
    },
    '3': {
      id: '3',
      title: 'Les rituels d\'accueil',
      type: 'markdown',
      content: `# ***Le développement psychomoteur et psychologique de l'enfant***

L'auxiliaire de puériculture doit connaître les étapes clés du développement de l'enfant pour repérer d'éventuelles anomalies et adapter sa prise en charge.  
 Bien que chaque enfant évolue à son propre rythme, il est essentiel de comprendre la progression typique du développement pour identifier les retards nécessitant une intervention précoce.

---

# **1\\. Les grandes étapes du développement psychomoteur et psychologique**

Le développement de l'enfant repose sur une interaction entre la **motricité** , le **langage** , la **socialisation** et le **développement psychologique** .  
L'évolution suit une progression **céphalo-caudale** (de la tête aux pieds) et **proximo-distale** (du tronc vers les extrémités).

## a) De 0 à 3 mois : premières interactions et découverte du corps

* **Motricité globale** : réflexes primitifs (saisir, Moro, succion) ; maintien bref de la tête en position ventrale.  
* **Motricité fine** : poings souvent fermés ; réflexe d'agrippement.  
* **Développement sensoriel et social** : réaction aux sons, suivi visuel des objets, sourire social à partir de 6 semaines, gazouillis.  
* **Aspect psychologique** :  
  * Développement de l'attachement avec les figures parentales (théorie de l'attachement de Bowlby).  
  * Sensibilité aux interactions, importance du **contact peau à peau** pour la sécurité affective.  
  * Le bébé commence à exprimer des émotions de base (plaisir, inconfort).`,
      moduleId: '1',
      subModuleId: '1'
    },
    '2': {
      id: '2',
      title: 'L\'adaptation progressive',
      type: 'text',
      content: `# L'adaptation progressive de l'enfant

L'adaptation est une période cruciale qui permet à l'enfant de s'habituer progressivement à son nouveau lieu d'accueil et aux personnes qui s'occuperont de lui.

## Les étapes clés

1. **La première rencontre**
   - Prévoir un temps d'échange avec les parents
   - Observer les habitudes de l'enfant
   - Établir un premier contact en douceur

2. **La séparation progressive**
   - Commencer par des temps courts
   - Augmenter progressivement la durée
   - Respecter le rythme de l'enfant

3. **Les rituels rassurants**
   - Mettre en place des repères temporels
   - Créer des rituels d'accueil
   - Utiliser des objets transitionnels

## Les points d'attention

- Être à l'écoute des signes de l'enfant
- Maintenir une communication régulière avec les parents
- Adapter le planning selon les besoins

> "L'adaptation est un processus qui demande patience et observation"

### Conseils pratiques

* Préparer l'espace d'accueil
* Noter les observations quotidiennes
* Échanger régulièrement avec l'équipe
* Rester flexible dans l'organisation`,
      duration: '20 minutes',
      moduleId: '1',
      subModuleId: '1'
    }
    };
    return mockContent[courseId] || mockContent['1'];
  }
};

export const getModuleProgress = async (): Promise<ModuleProgress[]> => {
  try {
    return await api.getUserProgress();
  } catch (error) {
    console.warn('Failed to fetch from API, using mock data:', error);
    return [
    {
      moduleId: '1',
      moduleName: 'Accueil et accompagnement de l\'enfant',
      completedLessons: 8,
      totalLessons: 10,
      lastAccessedAt: '2024-03-20T14:30:00Z',
      progress: 80
    },
    {
      moduleId: '2',
      moduleName: 'Projet d\'accueil et prévention',
      completedLessons: 6,
      totalLessons: 8,
      lastAccessedAt: '2024-03-19T16:45:00Z',
      progress: 75
    },
    {
      moduleId: '3',
      moduleName: 'Accompagnement au quotidien',
      completedLessons: 4,
      totalLessons: 6,
      lastAccessedAt: '2024-03-18T11:20:00Z',
      progress: 67
    },
    {
      moduleId: '4',
      moduleName: 'Développement et épanouissement',
      completedLessons: 3,
      totalLessons: 7,
      lastAccessedAt: '2024-03-17T09:15:00Z',
      progress: 43
    },
    {
      moduleId: '5',
      moduleName: 'Communication professionnelle',
      completedLessons: 2,
      totalLessons: 5,
      lastAccessedAt: '2024-03-16T15:30:00Z',
      progress: 40
    }
    ].sort((a, b) => a.id.localeCompare(b.id));
  }
}